import React from "react";
import { SignUpButton as ClerkSignUpButton } from "@clerk/clerk-react";
import { Box, Button, Card, Typography } from "@mui/material";
import { useSignupErrorRecovery } from "../hooks/useSignupErrorRecovery";

/**
 * Wraps Clerk's SignUpButton with error recovery UI
 * Shows fallback options if signup modal gets stuck in embedded browser
 */
export const SignUpButton = ({ children, mode = "modal", ...props }) => {
  const { signupError, isStuck, retry, suggestOAuth, resetModal } =
    useSignupErrorRecovery();

  if (isStuck || signupError) {
    return (
      <Box>
        <Card
          sx={{
            p: 3,
            mb: 2,
            bgcolor: "#fff3cd",
            borderLeft: "4px solid #ff9800",
          }}
        >
          <Typography sx={{ mb: 1.5, fontWeight: 600, color: "#856404" }}>
            {signupError || "Signup seems stuck"}
          </Typography>

          <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
            <Button
              variant="outlined"
              size="small"
              onClick={retry}
              sx={{
                textTransform: "none",
                borderColor: "#856404",
                color: "#856404",
              }}
            >
              Retry
            </Button>

            <Button
              variant="outlined"
              size="small"
              onClick={resetModal}
              sx={{
                textTransform: "none",
                borderColor: "#856404",
                color: "#856404",
              }}
            >
              Reload
            </Button>

            <Button
              variant="outlined"
              size="small"
              onClick={suggestOAuth}
              sx={{
                textTransform: "none",
                borderColor: "#856404",
                color: "#856404",
              }}
            >
              Use Google/Facebook
            </Button>
          </Box>
        </Card>

        {/* Still show the signup button below error for re-attempt */}
        <ClerkSignUpButton mode={mode} {...props}>
          {children}
        </ClerkSignUpButton>
      </Box>
    );
  }

  return (
    <ClerkSignUpButton mode={mode} {...props}>
      {children}
    </ClerkSignUpButton>
  );
};

export default SignUpButton;
